module.exports = __webpack_public_path__ + "media/images/background-pdf-aa95e44bce691509c56d056301472ab9.png";